import {usePathname} from '@aboutyou/router';

export const usePathWithBrandFilter = () => {
  const pathname = usePathname();
  return (path: string): string => {
    const regex = /\/b\/shop\/([^/]+)/;
    const matches = pathname.match(regex);
    const brandValue = matches ? matches[1] : '';

    return `${path}?brand=${brandValue}`;
  };
};
